[
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 157,
   "school_code": 17501,
   "nom": "Laurentienne",
   "ville": "Val-Morin",
   "secteur": "privé",
   "rang_2022_2023": 69,
   "rang_moyenne_5_ans": "101",
   "tendance": "—",
   "cote_2022_2023": 7.9,
   "cote_moyenne_5_ans": "7.2",
   "ehdaa": 32.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 58501,
   "nom": "Champagneur",
   "ville": "Rawdon",
   "secteur": "privé",
   "rang_2022_2023": 187,
   "rang_moyenne_5_ans": "166",
   "tendance": "—",
   "cote_2022_2023": 6.3,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 51.7
 },
 {
   "id_2022": 183,
   "school_code_2022": 66501,
   "nom_2022": "Clarétain",
   "id": 175,
   "school_code": 65501,
   "nom": "Charles-Lemoyne-Sainte-Catherine",
   "ville": "Sainte-Catherine",
   "secteur": "privé",
   "rang_2022_2023": 52,
   "rang_moyenne_5_ans": "86",
   "tendance": "112233",
   "cote_2022_2023": 8.1,
   "cote_moyenne_5_ans": "7.5",
   "ehdaa": 32.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 62,
   "school_code": 65505,
   "nom": "Charles-Lemoyne-Longueuil",
   "ville": "Longueuil",
   "secteur": "privé",
   "rang_2022_2023": 104,
   "rang_moyenne_5_ans": "57",
   "tendance": "—",
   "cote_2022_2023": 7.3,
   "cote_moyenne_5_ans": "8.0",
   "ehdaa": 43.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 54,
   "school_code": 69501,
   "nom": "de Champigny",
   "ville": "Québec",
   "secteur": "privé",
   "rang_2022_2023": 127,
   "rang_moyenne_5_ans": "116",
   "tendance": "—",
   "cote_2022_2023": 6.9,
   "cote_moyenne_5_ans": "6.9",
   "ehdaa": 38.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 118,
   "school_code": 86501,
   "nom": "Mont-Sainte-Anne",
   "ville": "Sherbrooke",
   "secteur": "privé",
   "rang_2022_2023": 447,
   "rang_moyenne_5_ans": "354",
   "tendance": "998855",
   "cote_2022_2023": 2.9,
   "cote_moyenne_5_ans": "4.6",
   "ehdaa": 31.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 233,
   "school_code": 123501,
   "nom": "Mont-Sacré-Coeur",
   "ville": "Granby",
   "secteur": "privé",
   "rang_2022_2023": 90,
   "rang_moyenne_5_ans": "86",
   "tendance": "—",
   "cote_2022_2023": 7.5,
   "cote_moyenne_5_ans": "7.5",
   "ehdaa": 31.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 155,
   "school_code": 127501,
   "nom": "Notre-Dame-de-l'Assomption",
   "ville": "Nicolet",
   "secteur": "privé",
   "rang_2022_2023": 187,
   "rang_moyenne_5_ans": "229",
   "tendance": "—",
   "cote_2022_2023": 6.3,
   "cote_moyenne_5_ans": "5.8",
   "ehdaa": 43
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 186,
   "school_code": 147501,
   "nom": "Saint-Bernard",
   "ville": "Drummondville",
   "secteur": "privé",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 32.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 80,
   "school_code": 159501,
   "nom": "Saint-Paul",
   "ville": "Varennes",
   "secteur": "privé",
   "rang_2022_2023": 37,
   "rang_moyenne_5_ans": "56",
   "tendance": "112233",
   "cote_2022_2023": 8.5,
   "cote_moyenne_5_ans": "8.1",
   "ehdaa": 39.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 179,
   "school_code": 229501,
   "nom": "Maïmonide (Jacob Safra)",
   "ville": "Montréal",
   "secteur": "privé",
   "rang_2022_2023": 41,
   "rang_moyenne_5_ans": "65",
   "tendance": "—",
   "cote_2022_2023": 8.3,
   "cote_moyenne_5_ans": "7.9",
   "ehdaa": 30
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 25,
   "school_code": 314501,
   "nom": "Bromptonville",
   "ville": "Sherbrooke",
   "secteur": "privé",
   "rang_2022_2023": 334,
   "rang_moyenne_5_ans": "182",
   "tendance": "998855",
   "cote_2022_2023": 5.1,
   "cote_moyenne_5_ans": "6.2",
   "ehdaa": 45.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 214,
   "school_code": 315501,
   "nom": "du Verbe Divin",
   "ville": "Granby",
   "secteur": "privé",
   "rang_2022_2023": 127,
   "rang_moyenne_5_ans": "95",
   "tendance": "998855",
   "cote_2022_2023": 6.9,
   "cote_moyenne_5_ans": "7.3",
   "ehdaa": 31.5
 },
 {
   "id_2022": 32,
   "school_code_2022": 321501,
   "nom_2022": "Jeanne-Normandin",
   "id": null,
   "school_code": 321501,
   "nom": "Collège Boisbriand 2016",
   "ville": "Montréal",
   "secteur": "privé",
   "rang_2022_2023": 109,
   "rang_moyenne_5_ans": "251",
   "tendance": "112233",
   "cote_2022_2023": 7.2,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 38
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 65,
   "school_code": 336501,
   "nom": "Saint-Joseph",
   "ville": "Saint-Hyacinthe",
   "secteur": "privé",
   "rang_2022_2023": 62,
   "rang_moyenne_5_ans": "65",
   "tendance": "—",
   "cote_2022_2023": 8,
   "cote_moyenne_5_ans": "7.9",
   "ehdaa": 42
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 131,
   "school_code": 388501,
   "nom": "Sacred Heart",
   "ville": "Montréal",
   "secteur": "privé",
   "rang_2022_2023": 99,
   "rang_moyenne_5_ans": "65",
   "tendance": "—",
   "cote_2022_2023": 7.4,
   "cote_moyenne_5_ans": "7.9",
   "ehdaa": 37.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 91,
   "school_code": 404503,
   "nom": "Bialik",
   "ville": "Côte-Saint-Luc",
   "secteur": "privé",
   "rang_2022_2023": 99,
   "rang_moyenne_5_ans": "65",
   "tendance": "—",
   "cote_2022_2023": 7.4,
   "cote_moyenne_5_ans": "7.9",
   "ehdaa": 33.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 207,
   "school_code": 445501,
   "nom": "Collège Trinité",
   "ville": "Saint-Bruno-de-Montarville",
   "secteur": "privé",
   "rang_2022_2023": 44,
   "rang_moyenne_5_ans": "57",
   "tendance": "—",
   "cote_2022_2023": 8.2,
   "cote_moyenne_5_ans": "8.0",
   "ehdaa": 30.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 448501,
   "nom": "Sacré-Coeur",
   "ville": "Grenville-sur-la-Rouge",
   "secteur": "privé",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "146",
   "tendance": "—",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "6.5",
   "ehdaa": 30.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 3,
   "school_code": 449501,
   "nom": "des Hauts Sommets",
   "ville": "Saint-Tite-des-Caps",
   "secteur": "privé",
   "rang_2022_2023": 458,
   "rang_moyenne_5_ans": "416",
   "tendance": "—",
   "cote_2022_2023": 1.7,
   "cote_moyenne_5_ans": "1.4",
   "ehdaa": 80.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 221,
   "school_code": 464501,
   "nom": "Herzliah High School",
   "ville": "Montréal",
   "secteur": "privé",
   "rang_2022_2023": 69,
   "rang_moyenne_5_ans": "57",
   "tendance": "—",
   "cote_2022_2023": 7.9,
   "cote_moyenne_5_ans": "8.0",
   "ehdaa": 32
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 57,
   "school_code": 515501,
   "nom": "l'Eau-Vive",
   "ville": "Québec",
   "secteur": "privé",
   "rang_2022_2023": 232,
   "rang_moyenne_5_ans": "204",
   "tendance": "—",
   "cote_2022_2023": 5.9,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 36.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 126,
   "school_code": 524501,
   "nom": "Nouvelles Frontières",
   "ville": "Gatineau",
   "secteur": "privé",
   "rang_2022_2023": 39,
   "rang_moyenne_5_ans": "30",
   "tendance": "—",
   "cote_2022_2023": 8.4,
   "cote_moyenne_5_ans": "8.6",
   "ehdaa": 35.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 689016,
   "nom": "Monseigneur-Scheffer",
   "ville": "Blanc-Sablon",
   "secteur": "public",
   "rang_2022_2023": 78,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 7.7,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 47.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 110,
   "school_code": 711021,
   "nom": "Armand-Saint-Onge",
   "ville": "Amqui",
   "secteur": "public",
   "rang_2022_2023": 248,
   "rang_moyenne_5_ans": "274",
   "tendance": "112233",
   "cote_2022_2023": 5.8,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 37.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 152,
   "school_code": 712003,
   "nom": "Paul-Hubert",
   "ville": "Rimouski",
   "secteur": "public",
   "rang_2022_2023": 197,
   "rang_moyenne_5_ans": "242",
   "tendance": "—",
   "cote_2022_2023": 6.2,
   "cote_moyenne_5_ans": "5.7",
   "ehdaa": 35.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 74,
   "school_code": 712005,
   "nom": "du le Mistral",
   "ville": "Mont-Joli",
   "secteur": "public",
   "rang_2022_2023": 428,
   "rang_moyenne_5_ans": "380",
   "tendance": "—",
   "cote_2022_2023": 3.7,
   "cote_moyenne_5_ans": "4.1",
   "ehdaa": 41.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 145,
   "school_code": 713020,
   "nom": "Dégelis",
   "ville": "Dégelis",
   "secteur": "public",
   "rang_2022_2023": 362,
   "rang_moyenne_5_ans": "313",
   "tendance": "—",
   "cote_2022_2023": 4.8,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 34.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 82,
   "school_code": 713121,
   "nom": "Cabano",
   "ville": "Témiscouata-sur-le-Lac",
   "secteur": "public",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "217",
   "tendance": "—",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 38.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 71,
   "school_code": 713132,
   "nom": "du Transcontinental",
   "ville": "Pohénégamook",
   "secteur": "public",
   "rang_2022_2023": 287,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 5.5,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 44.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 229,
   "school_code": 714021,
   "nom": "Rivière-du-Loup",
   "ville": "Rivière-du-Loup",
   "secteur": "public",
   "rang_2022_2023": 146,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2022_2023": 6.6,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 31.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 49,
   "school_code": 714022,
   "nom": "Chanoine-Beaudet",
   "ville": "Saint-Pascal",
   "secteur": "public",
   "rang_2022_2023": 104,
   "rang_moyenne_5_ans": "182",
   "tendance": "112233",
   "cote_2022_2023": 7.3,
   "cote_moyenne_5_ans": "6.2",
   "ehdaa": 49.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 58,
   "school_code": 714023,
   "nom": "La Pocatière",
   "ville": "La Pocatière",
   "secteur": "public",
   "rang_2022_2023": 232,
   "rang_moyenne_5_ans": "251",
   "tendance": "—",
   "cote_2022_2023": 5.9,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 43.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 67,
   "school_code": 721016,
   "nom": "Cité étudiante",
   "ville": "Roberval",
   "secteur": "public",
   "rang_2022_2023": 369,
   "rang_moyenne_5_ans": "377",
   "tendance": "—",
   "cote_2022_2023": 4.7,
   "cote_moyenne_5_ans": "4.2",
   "ehdaa": 40.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 150,
   "school_code": 721039,
   "nom": "des Quatre-Vents",
   "ville": "Saint-Félicien",
   "secteur": "public",
   "rang_2022_2023": 187,
   "rang_moyenne_5_ans": "217",
   "tendance": "112233",
   "cote_2022_2023": 6.3,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 38.4
 },
 {
   "id_2022": 137,
   "school_code_2022": 721085,
   "nom_2022": "Jean-Dolbeau",
   "id": null,
   "school_code": 721085,
   "nom": "Grandes-Rivières",
   "ville": "Dolbeau-Mistassini",
   "secteur": "public",
   "rang_2022_2023": 326,
   "rang_moyenne_5_ans": "322",
   "tendance": "—",
   "cote_2022_2023": 5.2,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 37.2
 },
 {
   "id_2022": 228,
   "school_code_2022": 722002,
   "nom_2022": "Camille-Lavoie",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": 47,
   "school_code_2022": 722003,
   "nom_2022": "Wilbrod-Dufour",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 722004,
   "nom": "Curé-Hébert",
   "ville": "Hébertville",
   "secteur": "public",
   "rang_2022_2023": 407,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 4.1,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 33.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 188,
   "school_code": 722009,
   "nom": "Jean-Gauthier",
   "ville": "Alma",
   "secteur": "public",
   "rang_2022_2023": 248,
   "rang_moyenne_5_ans": "377",
   "tendance": "112233",
   "cote_2022_2023": 5.8,
   "cote_moyenne_5_ans": "4.2",
   "ehdaa": 33.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 112,
   "school_code": 723145,
   "nom": "Charles-Gravel",
   "ville": "Saguenay",
   "secteur": "public",
   "rang_2022_2023": 326,
   "rang_moyenne_5_ans": "330",
   "tendance": "—",
   "cote_2022_2023": 5.2,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 39
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 158,
   "school_code": 723173,
   "nom": "des Grandes-Marées",
   "ville": "Saguenay",
   "secteur": "public",
   "rang_2022_2023": 417,
   "rang_moyenne_5_ans": "370",
   "tendance": "—",
   "cote_2022_2023": 4,
   "cote_moyenne_5_ans": "4.3",
   "ehdaa": 31.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 724003,
   "nom": "Kénogami",
   "ville": "Saguenay",
   "secteur": "public",
   "rang_2022_2023": 287,
   "rang_moyenne_5_ans": "166",
   "tendance": "998855",
   "cote_2022_2023": 5.5,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 30
 },
 {
   "id_2022": 114,
   "school_code_2022": 724014,
   "nom_2022": "Jonquière",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 220,
   "school_code": 731001,
   "nom": "Saint-Aubin",
   "ville": "Baie-Saint-Paul",
   "secteur": "public",
   "rang_2022_2023": 287,
   "rang_moyenne_5_ans": "137",
   "tendance": "—",
   "cote_2022_2023": 5.5,
   "cote_moyenne_5_ans": "6.6",
   "ehdaa": 31.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 218,
   "school_code": 731002,
   "nom": "du Plateau",
   "ville": "La Malbaie",
   "secteur": "public",
   "rang_2022_2023": 345,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 5,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 31.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 98,
   "school_code": 732161,
   "nom": "La Camaradière",
   "ville": "Québec",
   "secteur": "public",
   "rang_2022_2023": 388,
   "rang_moyenne_5_ans": "341",
   "tendance": "—",
   "cote_2022_2023": 4.5,
   "cote_moyenne_5_ans": "4.8",
   "ehdaa": 39.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 135,
   "school_code": 732164,
   "nom": "de Neufchâtel",
   "ville": "Québec",
   "secteur": "public",
   "rang_2022_2023": 216,
   "rang_moyenne_5_ans": "251",
   "tendance": "—",
   "cote_2022_2023": 6.1,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 37.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 161,
   "school_code": 732165,
   "nom": "Roger-Comtois",
   "ville": "Québec",
   "secteur": "public",
   "rang_2022_2023": 422,
   "rang_moyenne_5_ans": "361",
   "tendance": "—",
   "cote_2022_2023": 3.9,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 36.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 56,
   "school_code": 732167,
   "nom": "Vanier",
   "ville": "Québec",
   "secteur": "public",
   "rang_2022_2023": 442,
   "rang_moyenne_5_ans": "410",
   "tendance": "—",
   "cote_2022_2023": 3.2,
   "cote_moyenne_5_ans": "3.0",
   "ehdaa": 46.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 223,
   "school_code": 733002,
   "nom": "des Pionniers",
   "ville": "Saint-Augustin-de-Desmaures",
   "secteur": "public",
   "rang_2022_2023": 169,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 6.4,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 30.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 217,
   "school_code": 733030,
   "nom": "de L'Ancienne-Lorette",
   "ville": "L'Ancienne-Lorette",
   "secteur": "public",
   "rang_2022_2023": 121,
   "rang_moyenne_5_ans": "182",
   "tendance": "112233",
   "cote_2022_2023": 7,
   "cote_moyenne_5_ans": "6.2",
   "ehdaa": 34.5
 },
 {
   "id_2022": 222,
   "school_code_2022": 733032,
   "nom_2022": "les Compagnons-de-Cartier",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 96,
   "school_code": 734051,
   "nom": "Samuel-De Champlain",
   "ville": "Québec",
   "secteur": "public",
   "rang_2022_2023": 393,
   "rang_moyenne_5_ans": "322",
   "tendance": "—",
   "cote_2022_2023": 4.4,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 35.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 231,
   "school_code": 734065,
   "nom": "le Sommet",
   "ville": "Québec",
   "secteur": "public",
   "rang_2022_2023": 277,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 5.6,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 30.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 132,
   "school_code": 735013,
   "nom": "Louis-Jobin",
   "ville": "Saint-Raymond",
   "secteur": "public",
   "rang_2022_2023": 405,
   "rang_moyenne_5_ans": "370",
   "tendance": "—",
   "cote_2022_2023": 4.2,
   "cote_moyenne_5_ans": "4.3",
   "ehdaa": 37.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 6,
   "school_code": 741017,
   "nom": "Avenues-Nouvelles",
   "ville": "Trois-Rivières",
   "secteur": "public",
   "rang_2022_2023": 461,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 0.7,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 77.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 75,
   "school_code": 741108,
   "nom": "L'Escale",
   "ville": "Louiseville",
   "secteur": "public",
   "rang_2022_2023": 146,
   "rang_moyenne_5_ans": "146",
   "tendance": "—",
   "cote_2022_2023": 6.6,
   "cote_moyenne_5_ans": "6.5",
   "ehdaa": 39.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 212,
   "school_code": 741109,
   "nom": "Les Estacades",
   "ville": "Trois-Rivières",
   "secteur": "public",
   "rang_2022_2023": 334,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 5.1,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 30.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 146,
   "school_code": 741110,
   "nom": "des Pionniers",
   "ville": "Trois-Rivières",
   "secteur": "public",
   "rang_2022_2023": 146,
   "rang_moyenne_5_ans": "229",
   "tendance": "—",
   "cote_2022_2023": 6.6,
   "cote_moyenne_5_ans": "5.8",
   "ehdaa": 35.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 106,
   "school_code": 741111,
   "nom": "Chavigny",
   "ville": "Trois-Rivières",
   "secteur": "public",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "354",
   "tendance": "112233",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "4.6",
   "ehdaa": 38.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 203,
   "school_code": 741112,
   "nom": "le Tremplin",
   "ville": "Sainte-Geneviève-de-Batiscan",
   "secteur": "public",
   "rang_2022_2023": 169,
   "rang_moyenne_5_ans": "274",
   "tendance": "—",
   "cote_2022_2023": 6.4,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 41.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 205,
   "school_code": 742097,
   "nom": "Val-Mauricie",
   "ville": "Shawinigan",
   "secteur": "public",
   "rang_2022_2023": 121,
   "rang_moyenne_5_ans": "110",
   "tendance": "—",
   "cote_2022_2023": 7,
   "cote_moyenne_5_ans": "7.0",
   "ehdaa": 33.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 142,
   "school_code": 742100,
   "nom": "des Chutes",
   "ville": "Shawinigan",
   "secteur": "public",
   "rang_2022_2023": 248,
   "rang_moyenne_5_ans": "217",
   "tendance": "—",
   "cote_2022_2023": 5.8,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 32.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 208,
   "school_code": 742105,
   "nom": "Paul-Le Jeune",
   "ville": "Saint-Tite",
   "secteur": "public",
   "rang_2022_2023": 169,
   "rang_moyenne_5_ans": "229",
   "tendance": "112233",
   "cote_2022_2023": 6.4,
   "cote_moyenne_5_ans": "5.8",
   "ehdaa": 31.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 121,
   "school_code": 742118,
   "nom": "Champagnat",
   "ville": "La Tuque",
   "secteur": "public",
   "rang_2022_2023": 216,
   "rang_moyenne_5_ans": "146",
   "tendance": "998855",
   "cote_2022_2023": 6.1,
   "cote_moyenne_5_ans": "6.5",
   "ehdaa": 38.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 190,
   "school_code": 751006,
   "nom": "Montignac",
   "ville": "Lac-Mégantic",
   "secteur": "public",
   "rang_2022_2023": 169,
   "rang_moyenne_5_ans": "182",
   "tendance": "—",
   "cote_2022_2023": 6.4,
   "cote_moyenne_5_ans": "6.2",
   "ehdaa": 31.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 89,
   "school_code": 751007,
   "nom": "Louis-Saint-Laurent",
   "ville": "East Angus",
   "secteur": "public",
   "rang_2022_2023": 315,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 5.3,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 37.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 9,
   "school_code": 751008,
   "nom": "La MFR",
   "ville": "Saint-Romain",
   "secteur": "public",
   "rang_2022_2023": 442,
   "rang_moyenne_5_ans": "399",
   "tendance": "—",
   "cote_2022_2023": 3.2,
   "cote_moyenne_5_ans": "3.7",
   "ehdaa": 52.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 177,
   "school_code": 752117,
   "nom": "de la Montée",
   "ville": "Sherbrooke",
   "secteur": "public",
   "rang_2022_2023": 315,
   "rang_moyenne_5_ans": "251",
   "tendance": "—",
   "cote_2022_2023": 5.3,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 35.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 104,
   "school_code": 752148,
   "nom": "du Phare",
   "ville": "Sherbrooke",
   "secteur": "public",
   "rang_2022_2023": 369,
   "rang_moyenne_5_ans": "341",
   "tendance": "—",
   "cote_2022_2023": 4.7,
   "cote_moyenne_5_ans": "4.8",
   "ehdaa": 39
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 36,
   "school_code": 753012,
   "nom": "de L'Escale",
   "ville": "Asbestos",
   "secteur": "public",
   "rang_2022_2023": 345,
   "rang_moyenne_5_ans": "354",
   "tendance": "—",
   "cote_2022_2023": 5,
   "cote_moyenne_5_ans": "4.6",
   "ehdaa": 42
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 159,
   "school_code": 753027,
   "nom": "de la Ruche",
   "ville": "Magog",
   "secteur": "public",
   "rang_2022_2023": 137,
   "rang_moyenne_5_ans": "166",
   "tendance": "—",
   "cote_2022_2023": 6.8,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 36.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 125,
   "school_code": 753053,
   "nom": "l'Odyssée",
   "ville": "Valcourt",
   "secteur": "public",
   "rang_2022_2023": 334,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 5.1,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 41.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 115,
   "school_code": 753057,
   "nom": "du Tournesol",
   "ville": "Windsor",
   "secteur": "public",
   "rang_2022_2023": 303,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 5.4,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 41.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 761071,
   "nom": "Pointe-aux-Trembles",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 169,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2022_2023": 6.4,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 31.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 195,
   "school_code": 761078,
   "nom": "École sec. Anjou",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 379,
   "rang_moyenne_5_ans": "348",
   "tendance": "—",
   "cote_2022_2023": 4.6,
   "cote_moyenne_5_ans": "4.7",
   "ehdaa": 32.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 102,
   "school_code": 761090,
   "nom": "Calixa-Lavallée",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 407,
   "rang_moyenne_5_ans": "391",
   "tendance": "—",
   "cote_2022_2023": 4.1,
   "cote_moyenne_5_ans": "3.9",
   "ehdaa": 34.2
 },
 {
   "id_2022": 33,
   "school_code_2022": 762248,
   "nom_2022": "Éc. le Vitrail",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 209,
   "school_code": 762252,
   "nom": "Louise-Trichet",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 169,
   "rang_moyenne_5_ans": "158",
   "tendance": "—",
   "cote_2022_2023": 6.4,
   "cote_moyenne_5_ans": "6.4",
   "ehdaa": 32.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 66,
   "school_code": 762253,
   "nom": "Dunton",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 369,
   "rang_moyenne_5_ans": "348",
   "tendance": "—",
   "cote_2022_2023": 4.7,
   "cote_moyenne_5_ans": "4.7",
   "ehdaa": 41.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 149,
   "school_code": 762256,
   "nom": "Édouard-Montpetit",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 426,
   "rang_moyenne_5_ans": "384",
   "tendance": "—",
   "cote_2022_2023": 3.8,
   "cote_moyenne_5_ans": "4.0",
   "ehdaa": 32.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 8,
   "school_code": 762259,
   "nom": "Chomedey-De-Maisonneuve",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 447,
   "rang_moyenne_5_ans": "415",
   "tendance": "—",
   "cote_2022_2023": 2.9,
   "cote_moyenne_5_ans": "1.8",
   "ehdaa": 60.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 63,
   "school_code": 762263,
   "nom": "Louis-Joseph-Papineau",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 433,
   "rang_moyenne_5_ans": "405",
   "tendance": "—",
   "cote_2022_2023": 3.5,
   "cote_moyenne_5_ans": "3.4",
   "ehdaa": 37.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 15,
   "school_code": 762264,
   "nom": "Pierre-Dupuy",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 407,
   "rang_moyenne_5_ans": "380",
   "tendance": "—",
   "cote_2022_2023": 4.1,
   "cote_moyenne_5_ans": "4.1",
   "ehdaa": 51.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 64,
   "school_code": 762265,
   "nom": "Jeanne-Mance",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 417,
   "rang_moyenne_5_ans": "391",
   "tendance": "—",
   "cote_2022_2023": 4,
   "cote_moyenne_5_ans": "3.9",
   "ehdaa": 37.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 34,
   "school_code": 762269,
   "nom": "Georges-Vanier",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 379,
   "rang_moyenne_5_ans": "384",
   "tendance": "—",
   "cote_2022_2023": 4.6,
   "cote_moyenne_5_ans": "4.0",
   "ehdaa": 42
 },
 {
   "id_2022": 31,
   "school_code_2022": 762276,
   "nom_2022": "Marie-Anne",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 144,
   "school_code": 762278,
   "nom": "Lucien-Pagé",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 429,
   "rang_moyenne_5_ans": "384",
   "tendance": "998855",
   "cote_2022_2023": 3.6,
   "cote_moyenne_5_ans": "4.0",
   "ehdaa": 34.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 27,
   "school_code": 762286,
   "nom": "Saint-Henri",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 417,
   "rang_moyenne_5_ans": "396",
   "tendance": "—",
   "cote_2022_2023": 4,
   "cote_moyenne_5_ans": "3.8",
   "ehdaa": 43.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 140,
   "school_code": 762287,
   "nom": "Honoré-Mercier",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 369,
   "rang_moyenne_5_ans": "384",
   "tendance": "—",
   "cote_2022_2023": 4.7,
   "cote_moyenne_5_ans": "4.0",
   "ehdaa": 36.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 762291,
   "nom": "Saint-Luc",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 362,
   "rang_moyenne_5_ans": "166",
   "tendance": "—",
   "cote_2022_2023": 4.8,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 30.9
 },
 {
   "id_2022": 2,
   "school_code_2022": 763037,
   "nom_2022": "École du Sas",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 192,
   "school_code": 763138,
   "nom": "Cavelier-De LaSalle",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 400,
   "rang_moyenne_5_ans": "359",
   "tendance": "—",
   "cote_2022_2023": 4.3,
   "cote_moyenne_5_ans": "4.5",
   "ehdaa": 32.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 117,
   "school_code": 763139,
   "nom": "Dalbé-Viau",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 407,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2022_2023": 4.1,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 37
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 162,
   "school_code": 763142,
   "nom": "Monseigneur-Richard",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 146,
   "rang_moyenne_5_ans": "193",
   "tendance": "112233",
   "cote_2022_2023": 6.6,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 34.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 194,
   "school_code": 763236,
   "nom": "des Sources",
   "ville": "Dollard-Des Ormeaux",
   "secteur": "public",
   "rang_2022_2023": 287,
   "rang_moyenne_5_ans": "217",
   "tendance": "—",
   "cote_2022_2023": 5.5,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 35.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 763241,
   "nom": "Dorval-Jean XXIII",
   "ville": "Dorval",
   "secteur": "public",
   "rang_2022_2023": 287,
   "rang_moyenne_5_ans": "229",
   "tendance": "—",
   "cote_2022_2023": 5.5,
   "cote_moyenne_5_ans": "5.8",
   "ehdaa": 32.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 108,
   "school_code": 771022,
   "nom": "Nicolas-Gatineau",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2022_2023": 345,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 5,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 36.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 26,
   "school_code": 771033,
   "nom": "de L'Érablière",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "264",
   "tendance": "—",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 47.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 153,
   "school_code": 771035,
   "nom": "Le Carrefour",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2022_2023": 114,
   "rang_moyenne_5_ans": "204",
   "tendance": "—",
   "cote_2022_2023": 7.1,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 38.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 771038,
   "nom": "du Versant",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2022_2023": 197,
   "rang_moyenne_5_ans": "204",
   "tendance": "—",
   "cote_2022_2023": 6.2,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 32
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 772040,
   "nom": "Nouvelle-Ère",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2022_2023": 429,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 3.6,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 52.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 10,
   "school_code": 772042,
   "nom": "des Lacs",
   "ville": "La Pêche",
   "secteur": "public",
   "rang_2022_2023": 197,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 6.2,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 58
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 50,
   "school_code": 772044,
   "nom": "Grande-Rivière",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2022_2023": 157,
   "rang_moyenne_5_ans": "217",
   "tendance": "112233",
   "cote_2022_2023": 6.5,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 43.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 22,
   "school_code": 772046,
   "nom": "Mont-Bleu",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2022_2023": 232,
   "rang_moyenne_5_ans": "242",
   "tendance": "112233",
   "cote_2022_2023": 5.9,
   "cote_moyenne_5_ans": "5.7",
   "ehdaa": 48.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 60,
   "school_code": 772048,
   "nom": "de L'Île",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2022_2023": 315,
   "rang_moyenne_5_ans": "264",
   "tendance": "—",
   "cote_2022_2023": 5.3,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 36.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 136,
   "school_code": 773010,
   "nom": "Louis-Joseph-Papineau",
   "ville": "Papineauville",
   "secteur": "public",
   "rang_2022_2023": 248,
   "rang_moyenne_5_ans": "322",
   "tendance": "—",
   "cote_2022_2023": 5.8,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 34.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 48,
   "school_code": 773030,
   "nom": "Hormisdas-Gamelin",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2022_2023": 216,
   "rang_moyenne_5_ans": "229",
   "tendance": "—",
   "cote_2022_2023": 6.1,
   "cote_moyenne_5_ans": "5.8",
   "ehdaa": 41.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 28,
   "school_code": 774001,
   "nom": "Sieur-de-Coulonge",
   "ville": "Fort-Coulonge",
   "secteur": "public",
   "rang_2022_2023": 407,
   "rang_moyenne_5_ans": "361",
   "tendance": "—",
   "cote_2022_2023": 4.1,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 42.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 42,
   "school_code": 774003,
   "nom": "du Coeur-de-la-Gatineau",
   "ville": "Gracefield",
   "secteur": "public",
   "rang_2022_2023": 451,
   "rang_moyenne_5_ans": "411",
   "tendance": "—",
   "cote_2022_2023": 2.7,
   "cote_moyenne_5_ans": "2.8",
   "ehdaa": 53.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 68,
   "school_code": 774005,
   "nom": "La Cité étudiante",
   "ville": "Maniwaki",
   "secteur": "public",
   "rang_2022_2023": 388,
   "rang_moyenne_5_ans": "370",
   "tendance": "—",
   "cote_2022_2023": 4.5,
   "cote_moyenne_5_ans": "4.3",
   "ehdaa": 44.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 94,
   "school_code": 782018,
   "nom": "La Source",
   "ville": "Rouyn-Noranda",
   "secteur": "public",
   "rang_2022_2023": 169,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 6.4,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 37.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 156,
   "school_code": 782019,
   "nom": "D'Iberville",
   "ville": "Rouyn-Noranda",
   "secteur": "public",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "251",
   "tendance": "—",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 36.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 783006,
   "nom": "Natagan",
   "ville": "Barraute",
   "secteur": "public",
   "rang_2022_2023": 429,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 3.6,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 35.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 200,
   "school_code": 783023,
   "nom": "d'Amos",
   "ville": "Amos",
   "secteur": "public",
   "rang_2022_2023": 362,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 4.8,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 35.9
 },
 {
   "id_2022": 73,
   "school_code_2022": 784023,
   "nom_2022": "La Concorde",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 176,
   "school_code": 784024,
   "nom": "le Tremplin",
   "ville": "Malartic",
   "secteur": "public",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "229",
   "tendance": "—",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "5.8",
   "ehdaa": 33.9
 },
 {
   "id_2022": 199,
   "school_code_2022": 784025,
   "nom_2022": "Le Carrefour",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 182,
   "school_code": 785003,
   "nom": "Polyno",
   "ville": "La Sarre",
   "secteur": "public",
   "rang_2022_2023": 277,
   "rang_moyenne_5_ans": "283",
   "tendance": "112233",
   "cote_2022_2023": 5.6,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 39.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 791044,
   "nom": "Serge-Bouchard",
   "ville": "Baie-Comeau",
   "secteur": "public",
   "rang_2022_2023": 287,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 5.5,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 38.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 226,
   "school_code": 791046,
   "nom": "des Rivières",
   "ville": "Forestville",
   "secteur": "public",
   "rang_2022_2023": 287,
   "rang_moyenne_5_ans": "146",
   "tendance": "—",
   "cote_2022_2023": 5.5,
   "cote_moyenne_5_ans": "6.5",
   "ehdaa": 30.1
 },
 {
   "id_2022": 193,
   "school_code_2022": 791058,
   "nom_2022": "des Baies",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 123,
   "school_code": 792003,
   "nom": "Horizon-Blanc",
   "ville": "Fermont",
   "secteur": "public",
   "rang_2022_2023": 232,
   "rang_moyenne_5_ans": "217",
   "tendance": "—",
   "cote_2022_2023": 5.9,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 40.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 792047,
   "nom": "Jean-du-Nord / Manikoutai",
   "ville": "Sept-Îles",
   "secteur": "public",
   "rang_2022_2023": 326,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 5.2,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 35
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 97,
   "school_code": 792049,
   "nom": "L'Abri",
   "ville": "Port-Cartier",
   "secteur": "public",
   "rang_2022_2023": 379,
   "rang_moyenne_5_ans": "330",
   "tendance": "—",
   "cote_2022_2023": 4.6,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 44.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 18,
   "school_code": 793001,
   "nom": "Monseigneur-Labrie",
   "ville": "Havre-Saint-Pierre",
   "secteur": "public",
   "rang_2022_2023": 303,
   "rang_moyenne_5_ans": "313",
   "tendance": "—",
   "cote_2022_2023": 5.4,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 50.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 198,
   "school_code": 801003,
   "nom": "La Porte-du-Nord",
   "ville": "Chibougamau",
   "secteur": "public",
   "rang_2022_2023": 223,
   "rang_moyenne_5_ans": "125",
   "tendance": "998855",
   "cote_2022_2023": 6,
   "cote_moyenne_5_ans": "6.8",
   "ehdaa": 31.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 187,
   "school_code": 801014,
   "nom": "Le Delta",
   "ville": "Matagami",
   "secteur": "public",
   "rang_2022_2023": 345,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 5,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 38.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 163,
   "school_code": 801016,
   "nom": "La Taïga",
   "ville": "Lebel-sur-Quévillon",
   "secteur": "public",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 33
 },
 {
   "id_2022": 45,
   "school_code_2022": 812001,
   "nom_2022": "Saint-Norbert",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 169,
   "school_code": 811002,
   "nom": "des Îles",
   "ville": "Les Îles-de-la-Madeleine",
   "secteur": "public",
   "rang_2022_2023": 197,
   "rang_moyenne_5_ans": "166",
   "tendance": "—",
   "cote_2022_2023": 6.2,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 39.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 17,
   "school_code": 812006,
   "nom": "Gabriel-Le Courtois",
   "ville": "Sainte-Anne-des-Monts",
   "secteur": "public",
   "rang_2022_2023": 454,
   "rang_moyenne_5_ans": "361",
   "tendance": "998855",
   "cote_2022_2023": 2.2,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 50.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 76,
   "school_code": 812025,
   "nom": "Esdras-Minville",
   "ville": "Grande-Vallée",
   "secteur": "public",
   "rang_2022_2023": 393,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 4.4,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 42.4
 },
 {
   "id_2022": 234,
   "school_code_2022": 812034,
   "nom_2022": "Antoine-Roy",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 95,
   "school_code": 812040,
   "nom": "C.-E.-Pouliot",
   "ville": "Gaspé",
   "secteur": "public",
   "rang_2022_2023": 369,
   "rang_moyenne_5_ans": "348",
   "tendance": "—",
   "cote_2022_2023": 4.7,
   "cote_moyenne_5_ans": "4.7",
   "ehdaa": 35.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 191,
   "school_code": 813012,
   "nom": "Monseigneur Sévigny",
   "ville": "Chandler",
   "secteur": "public",
   "rang_2022_2023": 438,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 3.3,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 35.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 202,
   "school_code": 813022,
   "nom": "Paspébiac",
   "ville": "Paspébiac",
   "secteur": "public",
   "rang_2022_2023": 287,
   "rang_moyenne_5_ans": "137",
   "tendance": "—",
   "cote_2022_2023": 5.5,
   "cote_moyenne_5_ans": "6.6",
   "ehdaa": 37.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 813027,
   "nom": "aux Quatre-Vents",
   "ville": "Bonaventure",
   "secteur": "public",
   "rang_2022_2023": 216,
   "rang_moyenne_5_ans": "229",
   "tendance": "—",
   "cote_2022_2023": 6.1,
   "cote_moyenne_5_ans": "5.8",
   "ehdaa": 32.3
 },
 {
   "id_2022": 180,
   "school_code_2022": 813036,
   "nom_2022": "Antoine-Bernard",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 16,
   "school_code": 813042,
   "nom": "des Deux-Rivières",
   "ville": "Matapédia",
   "secteur": "public",
   "rang_2022_2023": 287,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2022_2023": 5.5,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 53.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 821216,
   "nom": "Saint-Anselme",
   "ville": "Saint-Anselme",
   "secteur": "public",
   "rang_2022_2023": 345,
   "rang_moyenne_5_ans": "274",
   "tendance": "998855",
   "cote_2022_2023": 5,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 33.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 821251,
   "nom": "Bon-Pasteur",
   "ville": "L'Islet",
   "secteur": "public",
   "rang_2022_2023": 388,
   "rang_moyenne_5_ans": "403",
   "tendance": "112233",
   "cote_2022_2023": 4.5,
   "cote_moyenne_5_ans": "3.5",
   "ehdaa": 32.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 232,
   "school_code": 821261,
   "nom": "Saint-Paul",
   "ville": "Saint-Paul-de-Montminy",
   "secteur": "public",
   "rang_2022_2023": 426,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 3.8,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 31.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 821277,
   "nom": "de la Rencontre",
   "ville": "Saint-Pamphile",
   "secteur": "public",
   "rang_2022_2023": 315,
   "rang_moyenne_5_ans": "274",
   "tendance": "—",
   "cote_2022_2023": 5.3,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 30.2
 },
 {
   "id_2022": 147,
   "school_code_2022": 822040,
   "nom_2022": "Disraëli",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 211,
   "school_code": 823045,
   "nom": "des Abénaquis",
   "ville": "Saint-Prosper",
   "secteur": "public",
   "rang_2022_2023": 303,
   "rang_moyenne_5_ans": "361",
   "tendance": "—",
   "cote_2022_2023": 5.4,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 37.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 85,
   "school_code": 831102,
   "nom": "Curé-Antoine-Labelle",
   "ville": "Laval",
   "secteur": "public",
   "rang_2022_2023": 277,
   "rang_moyenne_5_ans": "251",
   "tendance": "—",
   "cote_2022_2023": 5.6,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 43.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 81,
   "school_code": 831105,
   "nom": "Horizon Jeunesse",
   "ville": "Laval",
   "secteur": "public",
   "rang_2022_2023": 223,
   "rang_moyenne_5_ans": "204",
   "tendance": "—",
   "cote_2022_2023": 6,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 39.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 77,
   "school_code": 831107,
   "nom": "Leblanc",
   "ville": "Laval",
   "secteur": "public",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "204",
   "tendance": "—",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 41.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 46,
   "school_code": 831108,
   "nom": "Georges-Vanier",
   "ville": "Laval",
   "secteur": "public",
   "rang_2022_2023": 248,
   "rang_moyenne_5_ans": "313",
   "tendance": "112233",
   "cote_2022_2023": 5.8,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 44.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 130,
   "school_code": 831114,
   "nom": "Mont-de-La Salle",
   "ville": "Laval",
   "secteur": "public",
   "rang_2022_2023": 379,
   "rang_moyenne_5_ans": "348",
   "tendance": "—",
   "cote_2022_2023": 4.6,
   "cote_moyenne_5_ans": "4.7",
   "ehdaa": 38.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 30,
   "school_code": 841008,
   "nom": "du Coteau",
   "ville": "Mascouche",
   "secteur": "public",
   "rang_2022_2023": 393,
   "rang_moyenne_5_ans": "330",
   "tendance": "998855",
   "cote_2022_2023": 4.4,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 48.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 99,
   "school_code": 841031,
   "nom": "Paul-Arseneau",
   "ville": "L'Assomption",
   "secteur": "public",
   "rang_2022_2023": 197,
   "rang_moyenne_5_ans": "229",
   "tendance": "—",
   "cote_2022_2023": 6.2,
   "cote_moyenne_5_ans": "5.8",
   "ehdaa": 38.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 61,
   "school_code": 841038,
   "nom": "l'Horizon",
   "ville": "Repentigny",
   "secteur": "public",
   "rang_2022_2023": 248,
   "rang_moyenne_5_ans": "341",
   "tendance": "—",
   "cote_2022_2023": 5.8,
   "cote_moyenne_5_ans": "4.8",
   "ehdaa": 47
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 29,
   "school_code": 841050,
   "nom": "de l'Amitié",
   "ville": "L'Assomption",
   "secteur": "public",
   "rang_2022_2023": 447,
   "rang_moyenne_5_ans": "402",
   "tendance": "998855",
   "cote_2022_2023": 2.9,
   "cote_moyenne_5_ans": "3.6",
   "ehdaa": 45.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 154,
   "school_code": 841105,
   "nom": "le Prélude",
   "ville": "Mascouche",
   "secteur": "public",
   "rang_2022_2023": 388,
   "rang_moyenne_5_ans": "264",
   "tendance": "998855",
   "cote_2022_2023": 4.5,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 38.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 841108,
   "nom": "Des Rives",
   "ville": "Terrebonne",
   "secteur": "public",
   "rang_2022_2023": 197,
   "rang_moyenne_5_ans": "217",
   "tendance": "112233",
   "cote_2022_2023": 6.2,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 30.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 40,
   "school_code": 841131,
   "nom": "de l'Odyssée",
   "ville": "Terrebonne",
   "secteur": "public",
   "rang_2022_2023": 345,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2022_2023": 5,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 44.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 160,
   "school_code": 841134,
   "nom": "des Trois-Saisons",
   "ville": "Terrebonne",
   "secteur": "public",
   "rang_2022_2023": 146,
   "rang_moyenne_5_ans": "242",
   "tendance": "112233",
   "cote_2022_2023": 6.6,
   "cote_moyenne_5_ans": "5.7",
   "ehdaa": 30.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 37,
   "school_code": 842009,
   "nom": "du Havre-Jeunesse",
   "ville": "Sainte-Julienne",
   "secteur": "public",
   "rang_2022_2023": 422,
   "rang_moyenne_5_ans": "407",
   "tendance": "—",
   "cote_2022_2023": 3.9,
   "cote_moyenne_5_ans": "3.2",
   "ehdaa": 46.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 120,
   "school_code": 842098,
   "nom": "de L'Achigan",
   "ville": "Saint-Roch-de-l'Achigan",
   "secteur": "public",
   "rang_2022_2023": 442,
   "rang_moyenne_5_ans": "406",
   "tendance": "—",
   "cote_2022_2023": 3.2,
   "cote_moyenne_5_ans": "3.3",
   "ehdaa": 35.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 196,
   "school_code": 842103,
   "nom": "Thérèse-Martin",
   "ville": "Joliette",
   "secteur": "public",
   "rang_2022_2023": 303,
   "rang_moyenne_5_ans": "274",
   "tendance": "—",
   "cote_2022_2023": 5.4,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 31.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 206,
   "school_code": 842104,
   "nom": "Pierre-de-Lestage",
   "ville": "Berthierville",
   "secteur": "public",
   "rang_2022_2023": 438,
   "rang_moyenne_5_ans": "403",
   "tendance": "—",
   "cote_2022_2023": 3.3,
   "cote_moyenne_5_ans": "3.5",
   "ehdaa": 30
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 172,
   "school_code": 842105,
   "nom": "Barthélemy-Joliette",
   "ville": "Joliette",
   "secteur": "public",
   "rang_2022_2023": 287,
   "rang_moyenne_5_ans": "384",
   "tendance": "—",
   "cote_2022_2023": 5.5,
   "cote_moyenne_5_ans": "4.0",
   "ehdaa": 35.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 35,
   "school_code": 842108,
   "nom": "Bermon",
   "ville": "Saint-Gabriel",
   "secteur": "public",
   "rang_2022_2023": 460,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 0.9,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 48.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 72,
   "school_code": 842109,
   "nom": "des Chutes",
   "ville": "Rawdon",
   "secteur": "public",
   "rang_2022_2023": 434,
   "rang_moyenne_5_ans": "413",
   "tendance": "—",
   "cote_2022_2023": 3.4,
   "cote_moyenne_5_ans": "2.6",
   "ehdaa": 47.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 52,
   "school_code": 842199,
   "nom": "de L'Érablière",
   "ville": "Saint-Félix-de-Valois",
   "secteur": "public",
   "rang_2022_2023": 137,
   "rang_moyenne_5_ans": "242",
   "tendance": "112233",
   "cote_2022_2023": 6.8,
   "cote_moyenne_5_ans": "5.7",
   "ehdaa": 42.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 851102,
   "nom": "Oka",
   "ville": "Oka",
   "secteur": "public",
   "rang_2022_2023": 277,
   "rang_moyenne_5_ans": "193",
   "tendance": "998855",
   "cote_2022_2023": 5.6,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 33.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 168,
   "school_code": 851105,
   "nom": "Polyvalente Sainte-Thérèse",
   "ville": "Sainte-Thérèse",
   "secteur": "public",
   "rang_2022_2023": 121,
   "rang_moyenne_5_ans": "158",
   "tendance": "—",
   "cote_2022_2023": 7,
   "cote_moyenne_5_ans": "6.4",
   "ehdaa": 34.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 148,
   "school_code": 851106,
   "nom": "Lucille-Teasdale",
   "ville": "Blainville",
   "secteur": "public",
   "rang_2022_2023": 232,
   "rang_moyenne_5_ans": "204",
   "tendance": "—",
   "cote_2022_2023": 5.9,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 33.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 133,
   "school_code": 851108,
   "nom": "Henri-Dunant",
   "ville": "Blainville",
   "secteur": "public",
   "rang_2022_2023": 334,
   "rang_moyenne_5_ans": "264",
   "tendance": "—",
   "cote_2022_2023": 5.1,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 36.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 111,
   "school_code": 851143,
   "nom": "des Patriotes",
   "ville": "Saint-Eustache",
   "secteur": "public",
   "rang_2022_2023": 326,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 5.2,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 38.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 181,
   "school_code": 851144,
   "nom": "Deux-Montagnes",
   "ville": "Deux-Montagnes",
   "secteur": "public",
   "rang_2022_2023": 232,
   "rang_moyenne_5_ans": "217",
   "tendance": "—",
   "cote_2022_2023": 5.9,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 31.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 101,
   "school_code": 851171,
   "nom": "Jean-Jacques-Rousseau",
   "ville": "Boisbriand",
   "secteur": "public",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "361",
   "tendance": "112233",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 41
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 851172,
   "nom": "du Harfang",
   "ville": "Sainte-Anne-des-Plaines",
   "secteur": "public",
   "rang_2022_2023": 232,
   "rang_moyenne_5_ans": "283",
   "tendance": "112233",
   "cote_2022_2023": 5.9,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 31.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 852041,
   "nom": "des Hauts-Sommets",
   "ville": "Saint-Jérôme",
   "secteur": "public",
   "rang_2022_2023": 197,
   "rang_moyenne_5_ans": "166",
   "tendance": "—",
   "cote_2022_2023": 6.2,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 31.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 122,
   "school_code": 852059,
   "nom": "Lavigne",
   "ville": "Lachute",
   "secteur": "public",
   "rang_2022_2023": 362,
   "rang_moyenne_5_ans": "330",
   "tendance": "—",
   "cote_2022_2023": 4.8,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 40.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 128,
   "school_code": 853001,
   "nom": "Curé-Mercure",
   "ville": "Mont-Tremblant",
   "secteur": "public",
   "rang_2022_2023": 232,
   "rang_moyenne_5_ans": "264",
   "tendance": "—",
   "cote_2022_2023": 5.9,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 34.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 84,
   "school_code": 853028,
   "nom": "Monts",
   "ville": "Sainte-Agathe-des-Monts",
   "secteur": "public",
   "rang_2022_2023": 127,
   "rang_moyenne_5_ans": "137",
   "tendance": "—",
   "cote_2022_2023": 6.9,
   "cote_moyenne_5_ans": "6.6",
   "ehdaa": 41.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 70,
   "school_code": 854017,
   "nom": "Saint-Joseph",
   "ville": "Mont-Laurier",
   "secteur": "public",
   "rang_2022_2023": 197,
   "rang_moyenne_5_ans": "166",
   "tendance": "—",
   "cote_2022_2023": 6.2,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 30.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 134,
   "school_code": 861005,
   "nom": "Fernand-Lefebvre",
   "ville": "Sorel-Tracy",
   "secteur": "public",
   "rang_2022_2023": 379,
   "rang_moyenne_5_ans": "384",
   "tendance": "112233",
   "cote_2022_2023": 4.6,
   "cote_moyenne_5_ans": "4.0",
   "ehdaa": 33.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 166,
   "school_code": 862002,
   "nom": "Casavant",
   "ville": "Saint-Hyacinthe",
   "secteur": "public",
   "rang_2022_2023": 303,
   "rang_moyenne_5_ans": "322",
   "tendance": "112233",
   "cote_2022_2023": 5.4,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 35.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 113,
   "school_code": 862005,
   "nom": "Hyacinthe-Delorme",
   "ville": "Saint-Hyacinthe",
   "secteur": "public",
   "rang_2022_2023": 326,
   "rang_moyenne_5_ans": "251",
   "tendance": "—",
   "cote_2022_2023": 5.2,
   "cote_moyenne_5_ans": "5.6",
   "ehdaa": 40.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 51,
   "school_code": 862052,
   "nom": "Robert-Ouimet",
   "ville": "Acton Vale",
   "secteur": "public",
   "rang_2022_2023": 334,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2022_2023": 5.1,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 47.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 139,
   "school_code": 863005,
   "nom": "Paul-Germain-Ostiguy",
   "ville": "Saint-Césaire",
   "secteur": "public",
   "rang_2022_2023": 369,
   "rang_moyenne_5_ans": "391",
   "tendance": "—",
   "cote_2022_2023": 4.7,
   "cote_moyenne_5_ans": "3.9",
   "ehdaa": 33.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 863067,
   "nom": "Chanoine-Armand-Racicot",
   "ville": "Saint-Jean-sur-Richelieu",
   "secteur": "public",
   "rang_2022_2023": 197,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 6.2,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 30.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 174,
   "school_code": 863069,
   "nom": "Monseigneur-Euclide-Théberge",
   "ville": "Marieville",
   "secteur": "public",
   "rang_2022_2023": 169,
   "rang_moyenne_5_ans": "204",
   "tendance": "—",
   "cote_2022_2023": 6.4,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 33.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 23,
   "school_code": 864271,
   "nom": "l'Agora",
   "ville": "Longueuil",
   "secteur": "public",
   "rang_2022_2023": 379,
   "rang_moyenne_5_ans": "330",
   "tendance": "—",
   "cote_2022_2023": 4.6,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 45.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 201,
   "school_code": 864276,
   "nom": "Antoine-Brossard",
   "ville": "Brossard",
   "secteur": "public",
   "rang_2022_2023": 400,
   "rang_moyenne_5_ans": "370",
   "tendance": "—",
   "cote_2022_2023": 4.3,
   "cote_moyenne_5_ans": "4.3",
   "ehdaa": 30.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 44,
   "school_code": 864278,
   "nom": "Gérard-Filion",
   "ville": "Longueuil",
   "secteur": "public",
   "rang_2022_2023": 453,
   "rang_moyenne_5_ans": "413",
   "tendance": "—",
   "cote_2022_2023": 2.3,
   "cote_moyenne_5_ans": "2.6",
   "ehdaa": 41.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 216,
   "school_code": 864280,
   "nom": "Jacques-Rousseau",
   "ville": "Longueuil",
   "secteur": "public",
   "rang_2022_2023": 393,
   "rang_moyenne_5_ans": "322",
   "tendance": "998855",
   "cote_2022_2023": 4.4,
   "cote_moyenne_5_ans": "5.0",
   "ehdaa": 32.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 90,
   "school_code": 864284,
   "nom": "Monseigneur-A.-M.-Parent",
   "ville": "Longueuil",
   "secteur": "public",
   "rang_2022_2023": 369,
   "rang_moyenne_5_ans": "396",
   "tendance": "—",
   "cote_2022_2023": 4.7,
   "cote_moyenne_5_ans": "3.8",
   "ehdaa": 40.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 167,
   "school_code": 864287,
   "nom": "Saint-Jean-Baptiste",
   "ville": "Longueuil",
   "secteur": "public",
   "rang_2022_2023": 407,
   "rang_moyenne_5_ans": "361",
   "tendance": "—",
   "cote_2022_2023": 4.1,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 36.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 19,
   "school_code": 865106,
   "nom": "Polybel",
   "ville": "Beloeil",
   "secteur": "public",
   "rang_2022_2023": 345,
   "rang_moyenne_5_ans": "330",
   "tendance": "—",
   "cote_2022_2023": 5,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 49.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 224,
   "school_code": 865117,
   "nom": "De Mortagne",
   "ville": "Boucherville",
   "secteur": "public",
   "rang_2022_2023": 114,
   "rang_moyenne_5_ans": "125",
   "tendance": "112233",
   "cote_2022_2023": 7.1,
   "cote_moyenne_5_ans": "6.8",
   "ehdaa": 33
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 24,
   "school_code": 865225,
   "nom": "du Mont-Bruno",
   "ville": "Saint-Bruno-de-Montarville",
   "secteur": "public",
   "rang_2022_2023": 379,
   "rang_moyenne_5_ans": "354",
   "tendance": "—",
   "cote_2022_2023": 4.6,
   "cote_moyenne_5_ans": "4.6",
   "ehdaa": 46.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 164,
   "school_code": 865276,
   "nom": "du Grand-Coteau",
   "ville": "Sainte-Julie",
   "secteur": "public",
   "rang_2022_2023": 287,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 5.5,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 38.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 151,
   "school_code": 865285,
   "nom": "le Carrefour",
   "ville": "Varennes",
   "secteur": "public",
   "rang_2022_2023": 355,
   "rang_moyenne_5_ans": "348",
   "tendance": "—",
   "cote_2022_2023": 4.9,
   "cote_moyenne_5_ans": "4.7",
   "ehdaa": 36.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 143,
   "school_code": 866051,
   "nom": "de la Haute-Ville",
   "ville": "Granby",
   "secteur": "public",
   "rang_2022_2023": 334,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 5.1,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 38.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 88,
   "school_code": 866052,
   "nom": "Joseph-Hermas-Leclerc",
   "ville": "Granby",
   "secteur": "public",
   "rang_2022_2023": 315,
   "rang_moyenne_5_ans": "361",
   "tendance": "—",
   "cote_2022_2023": 5.3,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 42.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 69,
   "school_code": 866053,
   "nom": "Wilfrid-Léger",
   "ville": "Waterloo",
   "secteur": "public",
   "rang_2022_2023": 369,
   "rang_moyenne_5_ans": "330",
   "tendance": "—",
   "cote_2022_2023": 4.7,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 39.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 225,
   "school_code": 866055,
   "nom": "Jean-Jacques-Bertrand",
   "ville": "Farnham",
   "secteur": "public",
   "rang_2022_2023": 157,
   "rang_moyenne_5_ans": "182",
   "tendance": "—",
   "cote_2022_2023": 6.5,
   "cote_moyenne_5_ans": "6.2",
   "ehdaa": 31.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 866057,
   "nom": "École Massey-Vanier",
   "ville": "Cowansville",
   "secteur": "public",
   "rang_2022_2023": 157,
   "rang_moyenne_5_ans": "182",
   "tendance": "—",
   "cote_2022_2023": 6.5,
   "cote_moyenne_5_ans": "6.2",
   "ehdaa": 32.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 178,
   "school_code": 867076,
   "nom": "Louis-Cyr",
   "ville": "Napierville",
   "secteur": "public",
   "rang_2022_2023": 146,
   "rang_moyenne_5_ans": "137",
   "tendance": "—",
   "cote_2022_2023": 6.6,
   "cote_moyenne_5_ans": "6.6",
   "ehdaa": 32.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 87,
   "school_code": 868035,
   "nom": "des Patriotes",
   "ville": "Beauharnois",
   "secteur": "public",
   "rang_2022_2023": 315,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2022_2023": 5.3,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 42.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 41,
   "school_code": 868039,
   "nom": "de la Baie-Saint-François",
   "ville": "Salaberry-de-Valleyfield",
   "secteur": "public",
   "rang_2022_2023": 400,
   "rang_moyenne_5_ans": "370",
   "tendance": "—",
   "cote_2022_2023": 4.3,
   "cote_moyenne_5_ans": "4.3",
   "ehdaa": 43.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 53,
   "school_code": 868040,
   "nom": "Arthur Pigeon",
   "ville": "Huntingdon",
   "secteur": "public",
   "rang_2022_2023": 442,
   "rang_moyenne_5_ans": "399",
   "tendance": "—",
   "cote_2022_2023": 3.2,
   "cote_moyenne_5_ans": "3.7",
   "ehdaa": 43.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 165,
   "school_code": 871012,
   "nom": "Jean-Nicolet",
   "ville": "Nicolet",
   "secteur": "public",
   "rang_2022_2023": 277,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 5.6,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 33.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 78,
   "school_code": 871013,
   "nom": "La Découverte",
   "ville": "Saint-Léonard-d'Aston",
   "secteur": "public",
   "rang_2022_2023": 248,
   "rang_moyenne_5_ans": "274",
   "tendance": "—",
   "cote_2022_2023": 5.8,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 41.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 138,
   "school_code": 871019,
   "nom": "les Seigneuries",
   "ville": "Saint-Pierre-les-Becquets",
   "secteur": "public",
   "rang_2022_2023": 417,
   "rang_moyenne_5_ans": "380",
   "tendance": "—",
   "cote_2022_2023": 4,
   "cote_moyenne_5_ans": "4.1",
   "ehdaa": 41.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 872067,
   "nom": "Le boisé",
   "ville": "Victoriaville",
   "secteur": "public",
   "rang_2022_2023": 187,
   "rang_moyenne_5_ans": "204",
   "tendance": "—",
   "cote_2022_2023": 6.3,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 30
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 93,
   "school_code": 872069,
   "nom": "La Samare",
   "ville": "Plessisville",
   "secteur": "public",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "110",
   "tendance": "—",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "7.0",
   "ehdaa": 38.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 227,
   "school_code": 872070,
   "nom": "Sainte-Marie",
   "ville": "Princeville",
   "secteur": "public",
   "rang_2022_2023": 232,
   "rang_moyenne_5_ans": "166",
   "tendance": "—",
   "cote_2022_2023": 5.9,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 38.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 173,
   "school_code": 872071,
   "nom": "Sainte-Anne",
   "ville": "Daveluyville",
   "secteur": "public",
   "rang_2022_2023": 197,
   "rang_moyenne_5_ans": "101",
   "tendance": "—",
   "cote_2022_2023": 6.2,
   "cote_moyenne_5_ans": "7.2",
   "ehdaa": 40.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 55,
   "school_code": 873050,
   "nom": "Jean-Raimbault",
   "ville": "Drummondville",
   "secteur": "public",
   "rang_2022_2023": 326,
   "rang_moyenne_5_ans": "242",
   "tendance": "—",
   "cote_2022_2023": 5.2,
   "cote_moyenne_5_ans": "5.7",
   "ehdaa": 44.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 109,
   "school_code": 873053,
   "nom": "Jeanne-Mance",
   "ville": "Drummondville",
   "secteur": "public",
   "rang_2022_2023": 315,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 5.3,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 37
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 170,
   "school_code": 873055,
   "nom": "Marie-Rivier",
   "ville": "Drummondville",
   "secteur": "public",
   "rang_2022_2023": 169,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2022_2023": 6.4,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 33.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 39,
   "school_code": 873057,
   "nom": "La Poudrière",
   "ville": "Drummondville",
   "secteur": "public",
   "rang_2022_2023": 422,
   "rang_moyenne_5_ans": "361",
   "tendance": "—",
   "cote_2022_2023": 3.9,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 47
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 881003,
   "nom": "Dollard-des-Ormeaux",
   "ville": "Shannon",
   "secteur": "public",
   "rang_2022_2023": 216,
   "rang_moyenne_5_ans": "146",
   "tendance": "—",
   "cote_2022_2023": 6.1,
   "cote_moyenne_5_ans": "6.5",
   "ehdaa": 35.2
 },
 {
   "id_2022": 119,
   "school_code_2022": 882002,
   "nom_2022": "New Carlisle",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 882006,
   "nom": "de Gaspé",
   "ville": "Gaspé",
   "secteur": "public",
   "rang_2022_2023": 400,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 4.3,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 38.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 43,
   "school_code": 882112,
   "nom": "Queen Elizabeth",
   "ville": "Sept-Îles",
   "secteur": "public",
   "rang_2022_2023": 223,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 6,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 43.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 20,
   "school_code": 883022,
   "nom": "Alexander Galt",
   "ville": "Sherbrooke",
   "secteur": "public",
   "rang_2022_2023": 355,
   "rang_moyenne_5_ans": "330",
   "tendance": "—",
   "cote_2022_2023": 4.9,
   "cote_moyenne_5_ans": "4.9",
   "ehdaa": 45.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 13,
   "school_code": 883023,
   "nom": "Massey-Vanier",
   "ville": "Cowansville",
   "secteur": "public",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 52.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 86,
   "school_code": 883024,
   "nom": "Richmond",
   "ville": "Richmond",
   "secteur": "public",
   "rang_2022_2023": 315,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 5.3,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 43.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 127,
   "school_code": 884001,
   "nom": "St. John's",
   "ville": "Saint-Jean-sur-Richelieu",
   "secteur": "public",
   "rang_2022_2023": 355,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2022_2023": 4.9,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 36.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 124,
   "school_code": 884016,
   "nom": "Heritage Regional",
   "ville": "Saint-Hubert",
   "secteur": "public",
   "rang_2022_2023": 232,
   "rang_moyenne_5_ans": "217",
   "tendance": "—",
   "cote_2022_2023": 5.9,
   "cote_moyenne_5_ans": "5.9",
   "ehdaa": 37.3
 },
 {
   "id_2022": 116,
   "school_code_2022": 884032,
   "nom_2022": "Chambly",
   "id": null,
   "school_code": 884032,
   "nom": "Saint-Lambert International",
   "ville": "Saint-Lambert",
   "secteur": "public",
   "rang_2022_2023": 303,
   "rang_moyenne_5_ans": "359",
   "tendance": "—",
   "cote_2022_2023": 5.4,
   "cote_moyenne_5_ans": "4.5",
   "ehdaa": 33.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 171,
   "school_code": 884035,
   "nom": "Centennial",
   "ville": "Greenfield Park",
   "secteur": "public",
   "rang_2022_2023": 216,
   "rang_moyenne_5_ans": "204",
   "tendance": "—",
   "cote_2022_2023": 6.1,
   "cote_moyenne_5_ans": "6.0",
   "ehdaa": 33.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 189,
   "school_code": 885181,
   "nom": "Joliette",
   "ville": "Joliette",
   "secteur": "public",
   "rang_2022_2023": 417,
   "rang_moyenne_5_ans": "274",
   "tendance": "—",
   "cote_2022_2023": 4,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 33.2
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 184,
   "school_code": 885183,
   "nom": "Lake of Two Mountains",
   "ville": "Deux-Montagnes",
   "secteur": "public",
   "rang_2022_2023": 362,
   "rang_moyenne_5_ans": "302",
   "tendance": "—",
   "cote_2022_2023": 4.8,
   "cote_moyenne_5_ans": "5.2",
   "ehdaa": 32.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 83,
   "school_code": 885189,
   "nom": "Ste-Agathe",
   "ville": "Sainte-Agathe-des-Monts",
   "secteur": "public",
   "rang_2022_2023": 232,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 5.9,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 41.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 105,
   "school_code": 886001,
   "nom": "Philemon Wright",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2022_2023": 169,
   "rang_moyenne_5_ans": "137",
   "tendance": "998855",
   "cote_2022_2023": 6.4,
   "cote_moyenne_5_ans": "6.6",
   "ehdaa": 37.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 12,
   "school_code": 886002,
   "nom": "Pontiac",
   "ville": "Shawville",
   "secteur": "public",
   "rang_2022_2023": 379,
   "rang_moyenne_5_ans": "370",
   "tendance": "—",
   "cote_2022_2023": 4.6,
   "cote_moyenne_5_ans": "4.3",
   "ehdaa": 47.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 103,
   "school_code": 886004,
   "nom": "D'Arcy McGee",
   "ville": "Gatineau",
   "secteur": "public",
   "rang_2022_2023": 232,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2022_2023": 5.9,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 40.5
 },
 {
   "id_2022": 59,
   "school_code_2022": 886005,
   "nom_2022": "Dr. Wilbert Keon",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 886006,
   "nom": "Golden Valley",
   "ville": "Val-d'Or",
   "secteur": "public",
   "rang_2022_2023": 434,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 3.4,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 36.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 11,
   "school_code": 886012,
   "nom": "Saint-Michael",
   "ville": "Low",
   "secteur": "public",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 55.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 230,
   "school_code": 887047,
   "nom": "F.A.C.E.",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 197,
   "rang_moyenne_5_ans": "146",
   "tendance": "—",
   "cote_2022_2023": 6.2,
   "cote_moyenne_5_ans": "6.5",
   "ehdaa": 44.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 4,
   "school_code": 887101,
   "nom": "James Lyng",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 459,
   "rang_moyenne_5_ans": "417",
   "tendance": "—",
   "cote_2022_2023": 1.2,
   "cote_moyenne_5_ans": "0.5",
   "ehdaa": 86.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 7,
   "school_code": 887102,
   "nom": "John F. Kennedy",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 451,
   "rang_moyenne_5_ans": "399",
   "tendance": "—",
   "cote_2022_2023": 2.7,
   "cote_moyenne_5_ans": "3.7",
   "ehdaa": 63.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 197,
   "school_code": 887104,
   "nom": "LaurenHill",
   "ville": "Saint-Laurent",
   "secteur": "public",
   "rang_2022_2023": 187,
   "rang_moyenne_5_ans": "193",
   "tendance": "—",
   "cote_2022_2023": 6.3,
   "cote_moyenne_5_ans": "6.1",
   "ehdaa": 33.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 219,
   "school_code": 887106,
   "nom": "Lester B. Pearson",
   "ville": "Montréal-Nord",
   "secteur": "public",
   "rang_2022_2023": 257,
   "rang_moyenne_5_ans": "264",
   "tendance": "—",
   "cote_2022_2023": 5.7,
   "cote_moyenne_5_ans": "5.5",
   "ehdaa": 33.7
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 129,
   "school_code": 887108,
   "nom": "Marymount",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 277,
   "rang_moyenne_5_ans": "313",
   "tendance": "—",
   "cote_2022_2023": 5.6,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 31.4
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 210,
   "school_code": 887110,
   "nom": "Rosemount",
   "ville": "Montréal",
   "secteur": "public",
   "rang_2022_2023": 303,
   "rang_moyenne_5_ans": "283",
   "tendance": "—",
   "cote_2022_2023": 5.4,
   "cote_moyenne_5_ans": "5.3",
   "ehdaa": 34.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 213,
   "school_code": 887116,
   "nom": "Westmount",
   "ville": "Westmount",
   "secteur": "public",
   "rang_2022_2023": 127,
   "rang_moyenne_5_ans": "166",
   "tendance": "—",
   "cote_2022_2023": 6.9,
   "cote_moyenne_5_ans": "6.3",
   "ehdaa": 31.8
 },
 {
   "id_2022": 1,
   "school_code_2022": 887203,
   "nom_2022": "Options II",
   "id": null,
   "school_code": null,
   "nom": "",
   "ville": "",
   "secteur": "",
   "rang_2022_2023": null,
   "rang_moyenne_5_ans": "",
   "tendance": "",
   "cote_2022_2023": null,
   "cote_moyenne_5_ans": "",
   "ehdaa": null
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 141,
   "school_code": 888051,
   "nom": "Beaconsfield",
   "ville": "Beaconsfield",
   "secteur": "public",
   "rang_2022_2023": 197,
   "rang_moyenne_5_ans": "182",
   "tendance": "—",
   "cote_2022_2023": 6.2,
   "cote_moyenne_5_ans": "6.2",
   "ehdaa": 39.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 107,
   "school_code": 888055,
   "nom": "Westwood",
   "ville": "Hudson",
   "secteur": "public",
   "rang_2022_2023": 146,
   "rang_moyenne_5_ans": "158",
   "tendance": "—",
   "cote_2022_2023": 6.6,
   "cote_moyenne_5_ans": "6.4",
   "ehdaa": 36.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 888057,
   "nom": "John Rennie",
   "ville": "Pointe-Claire",
   "secteur": "public",
   "rang_2022_2023": 127,
   "rang_moyenne_5_ans": "95",
   "tendance": "—",
   "cote_2022_2023": 6.9,
   "cote_moyenne_5_ans": "7.3",
   "ehdaa": 31.3
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 21,
   "school_code": 888058,
   "nom": "Lakeside",
   "ville": "Lachine",
   "secteur": "public",
   "rang_2022_2023": 355,
   "rang_moyenne_5_ans": "313",
   "tendance": "—",
   "cote_2022_2023": 4.9,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 53.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 185,
   "school_code": 888059,
   "nom": "LaSalle",
   "ville": "Lasalle",
   "secteur": "public",
   "rang_2022_2023": 362,
   "rang_moyenne_5_ans": "313",
   "tendance": "998855",
   "cote_2022_2023": 4.8,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 36.6
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 100,
   "school_code": 888061,
   "nom": "MacDonald",
   "ville": "Sainte-Anne-de-Bellevue",
   "secteur": "public",
   "rang_2022_2023": 334,
   "rang_moyenne_5_ans": "274",
   "tendance": "—",
   "cote_2022_2023": 5.1,
   "cote_moyenne_5_ans": "5.4",
   "ehdaa": 38.5
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 38,
   "school_code": 888062,
   "nom": "Pierrefonds",
   "ville": "Pierrefonds",
   "secteur": "public",
   "rang_2022_2023": 197,
   "rang_moyenne_5_ans": "146",
   "tendance": "—",
   "cote_2022_2023": 6.2,
   "cote_moyenne_5_ans": "6.5",
   "ehdaa": 45.1
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 14,
   "school_code": 888069,
   "nom": "Beurling",
   "ville": "Verdun",
   "secteur": "public",
   "rang_2022_2023": 407,
   "rang_moyenne_5_ans": "407",
   "tendance": "—",
   "cote_2022_2023": 4.1,
   "cote_moyenne_5_ans": "3.2",
   "ehdaa": 51.9
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": null,
   "school_code": 888079,
   "nom": "Horizon",
   "ville": "Pointe-Claire",
   "secteur": "public",
   "rang_2022_2023": 454,
   "rang_moyenne_5_ans": "nd",
   "tendance": "nd",
   "cote_2022_2023": 2.2,
   "cote_moyenne_5_ans": "nd",
   "ehdaa": 98.8
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 92,
   "school_code": 889014,
   "nom": "Châteauguay Valley",
   "ville": "Ormstown",
   "secteur": "public",
   "rang_2022_2023": 334,
   "rang_moyenne_5_ans": "313",
   "tendance": "—",
   "cote_2022_2023": 5.1,
   "cote_moyenne_5_ans": "5.1",
   "ehdaa": 38
 },
 {
   "id_2022": null,
   "school_code_2022": null,
   "nom_2022": "",
   "id": 79,
   "school_code": 889016,
   "nom": "Howard S. Billings",
   "ville": "Châteauguay",
   "secteur": "public",
   "rang_2022_2023": 355,
   "rang_moyenne_5_ans": "361",
   "tendance": "—",
   "cote_2022_2023": 4.9,
   "cote_moyenne_5_ans": "4.4",
   "ehdaa": 36.3
 }
]